import {
  call,
  put,
  takeLatest,
  takeEvery,
  fork,
  all,
} from 'redux-saga/effects';
import _ from 'lodash';

/* Actions */
import { addNotification } from 'containers/Notifications/actions';

/* Constants */

import {
  API_EXECUTE_WIDGET,
  API_EXECUTE_TEAM_WIDGET,
  API_EXPORT_WIDGET,
} from 'constants/appConstants';

import axios from 'constants/axios';

import { statusIsOk } from 'utils/api';
import { fetchFile } from 'utils/fetchFile';
import { buildWidgetsQuery } from 'containers/Team/sagas';

import { mockWidgetPreviewAPI } from 'containers/WidgetConfiguration/mockWidgetPreviewAPI';

import getTimezoneAbbr from 'utils/getTimezoneAbbr';
import { FETCH_WIDGET, EXPORT_WIDGET } from './constants';
import { fetchTeamWidgetSuccess, fetchTeamWidgetFailure } from './actions';

export function* fetchTeamWidget(action) {
  try {
    const { teamId, widgetID, pageSize, currentPage, sorting, filters } =
      action;

    const url = teamId
      ? API_EXECUTE_TEAM_WIDGET(teamId, widgetID)
      : API_EXECUTE_WIDGET(widgetID);

    const response = yield call(axios, {
      method: teamId ? 'post' : 'get',
      url: `${url}${buildWidgetsQuery(
        pageSize,
        currentPage,
        sorting,
        filters
      )}`,
    });

    if (statusIsOk(response)) {
      let results = response.data.result.executedWidget;
      if (action.isPreview) {
        const { data } = yield call(mockWidgetPreviewAPI, {
          definition: response.data.result.definition.definition,
        });
        results = {
          ...data.result,
          ...response.data.result.definition.definition,
        };
      }
      yield put(
        fetchTeamWidgetSuccess(
          action.widgetID,
          results,
          response.data.result.definition
        )
      );
    } else {
      yield all([
        put(fetchTeamWidgetFailure(action.widgetID, response.data.error)),
        put(
          addNotification(
            'error',
            'Invalid Widget. Please remove deleted widget from the dashboard'
          )
        ),
      ]);
    }
  } catch (error) {
    const errorText = 'Could not execute a widget';

    yield all([
      put(fetchTeamWidgetFailure(action.widgetID, error)),
      put(addNotification('error', errorText)),
    ]);
  }
}

export function* exportWidget(action) {
  try {
    const { teamID, widgetID, definition } = action;
    const url = `${API_EXPORT_WIDGET(teamID, widgetID)}`;

    if (_.isEmpty(definition)) {
      const apiUrl = `${url}?timezone=${_.lowerCase(getTimezoneAbbr())}`;
      fetchFile(
        apiUrl,
        _,
        addNotification('error', 'Download of widget failed')
      );
    } else {
      const widgetDefinition = definition.toJS();

      // satisfyAll will always be true until we re-introduce the FilterTypeSelector
      // for custom filter
      const { filters, satisfyAll } = widgetDefinition.filter;

      const filterString = filters
        .map((f) =>
          encodeURIComponent(
            `${f.field}+${f.operator}+${f.comparator}+${f.type}`
          )
        )
        .join('&filter=');

      const apiUrl = `${url}?filter=${filterString}&satisfyAll=${satisfyAll}&timezone=${_.lowerCase(
        getTimezoneAbbr()
      )}`;

      fetchFile(
        apiUrl,
        _,
        addNotification('error', 'Download of widget failed')
      );
    }
  } catch (err) {
    yield put(addNotification('error', 'Could not export widget'));
  }
}

export function* fetchTeamWidgetWatcher() {
  yield takeEvery(FETCH_WIDGET, fetchTeamWidget);
}

export function* exportWidgetWatcher() {
  yield takeLatest(EXPORT_WIDGET, exportWidget);
}

export function* rootSaga() {
  yield all([fork(exportWidgetWatcher)]);
}

export default [rootSaga];
